import styled from 'styled-components';
import { Heading1Text, SubheaderText, CaptionText } from '@/utils/global-fonts';
import { Col, Row } from '@/components/grid/grid-component';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 40px;
  margin-left: 40px;
`;
const ProductFilterGroupContainer = styled.div`
  display: flex !important;
  flex-direction: column !important;
`;

const ProductFilterGroupTitle = styled(Heading1Text)``;
const ProductFilterGroup = styled(Row)`
  row-gap: 30px;
`;

const ProductFilterGroupItemWrapper = styled(Col)`
  height: unset;
`;

const ProductFilterGroupItem = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  padding: 16px;
  flex-direction: column;
  cursor: pointer;
  border: 1px solid
    ${({ selected, theme }) =>
      selected ? theme.COLOR_PRIMARY : theme.COLOR_GREY2};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.COLOR_WHITE};
  transition: all 0.2s ease-in-out;
  @media (hover: hover) {
    &:hover {
      border: 1px solid ${({ theme }) => theme.COLOR_GREY1};
      .prodCatTitle {
        color: ${({ theme }) => theme.COLOR_BLACK} !important;
      }
    }
  }
  justify-content: space-between;
`;

const ProductFilterGroupItemTitle = styled(SubheaderText)`
  display: flex;
  gap: 5px;
`;
const TitleItems = styled.span``;

const ProductFilterGroupItemImage = styled.img`
  width: 100%;
  max-height: 150px;
  object-fit: contain;
  margin-bottom: 1.5rem;
`;

const ProductFilterGroupItemDescription = styled(CaptionText)`
  font-size: 12px;
  margin: 0;
  padding: 0 20px;
  color: ${({ theme }) => theme.COLOR_GREY_TEXT};
`;

const StyledFilterResults = {
  Container,
  ProductFilterGroupContainer,
  ProductFilterGroupTitle,
  TitleItems,
  ProductFilterGroup,
  ProductFilterGroupItem,
  ProductFilterGroupItemTitle,
  ProductFilterGroupItemImage,
  ProductFilterGroupItemDescription,
  ProductFilterGroupItemWrapper,
};

export default StyledFilterResults;
